module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Earth-7b1c7e002012882ec03edf879bb212e3.svg";